<template>
  <Card class="stats-card">
    <div class="stats-number">{{attCount}}</div>
    <div class="stats-title"><b>Total Attendees</b></div>
    <div><router-link :to="'/wc/'+webcast._id+'/attendee_report'">Attendee Report</router-link></div>
  </Card>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapActions
} from 'vuex'
import moment from 'moment'
export default {
  computed: {
    ...mapGetters('webcast', {
      webcast: 'getCopy',
    }),
    ...mapGetters('realtime-stats', {
      statsInStore: 'find'
    }),
    ...mapGetters('page-settings', {
      pageSettings: 'getCopy',
    }),
    attCount(){
      var stats =  this.statsInStore({
        query: {
          'webcastId': this.webcast._id,
          'sessionId': this.webcast.currentSessionId
        }
      })
      let attCount = 0;
      let deviceCount = 0;

      if(this.pageSettings.registrationEnabled){
        _.forEach(stats.data, function(stat) {
          attCount += stat.totalAtt
        });
        return attCount
      } else {
        _.forEach(stats.data, function(stat) {
          deviceCount += stat.totalDevice
        });
        return deviceCount
      }
    },
  },
  methods: {
  },
  created(){
  }
}
</script>

<style>

</style>
